import { MenuItemTypes } from "../../constants/menu";
import { IS_SABEEAPP, USER_IDENTITY, USER_PERMISSIONS } from "../../constants/storageKeys";
import { AuthenticationTypes, UserOperationTypes, } from "../types/AuthorizationProps";
import appHelpers from "./appHelpers";
import { decryptAES } from "./encryptonHelper";


 
const isAuthorizeByPermission =(authorizationTypes: UserOperationTypes[],permissions : Array<number> )=>{

    const found = permissions.some(r=> authorizationTypes?.includes(r))
    return found
}
export const isAuthorizeToComission =()=>{
    const userIdentity = getUserIdentity();

    if (userIdentity =="BAYİ/MÜŞTERİ") {
        return false;
    }
    return true;
}
export const isAuthorizeToFreePayment =()=>{
    const userIdentity = getUserIdentity();
    const permissions :Array<number>= JSON.parse(decryptAES(localStorage.getItem(USER_PERMISSIONS) || ""));

    if (userIdentity == "ADMIN" || permissions.indexOf(3) != -1 || userIdentity == "BANKUSER") {
        return true;
    }
    return false;
}
export const isUserAuthorizeToMenu = (menuItem: MenuItemTypes) => {

    try {
        const isSabeeFirm = localStorage.getItem(IS_SABEEAPP);
        const userIdentity = getUserIdentity();
        const permissions :Array<number>= JSON.parse(decryptAES(localStorage.getItem(USER_PERMISSIONS) || ""));
        const platform = appHelpers.getPlatform(); 
 
        if (platform != "web" && menuItem.isPortalMenu) {
            return false;
        }
        if (isSabeeFirm != "true" && menuItem.isSabeeAppMenu) {
            return false;
        }
        if (userIdentity == "ADMIN") {
            return true;
        }
        const found = permissions.some(r=> menuItem.authorizationTypes?.includes(r))
        if (found) {
            return true;
        } 
        
        if (menuItem.authenticationTypes && menuItem.authenticationTypes?.indexOf(userIdentity) != -1) {
            if (menuItem.authorizationTypes) {
                return isAuthorizeByPermission(menuItem.authorizationTypes, permissions);
            }else {
                return true;
            } 
        } 
        if (menuItem.isAdiminAccess) {
            return false;
        }
        if (!menuItem.authorizationTypes) {
            return true;
        }
    
    } catch (error) {
        return true;
    }
 
    return false;
}
export function getUserIdentity(): AuthenticationTypes {
    const userIdentity: any = decryptAES(localStorage.getItem(USER_IDENTITY) || "");
    return userIdentity;
}